import { Box, Typography } from '@mui/material'
import { useTheme } from '@emotion/react'

const Footer = () => {
  const theme = useTheme()
  return (
    <Box sx={{ textAlign: 'center', background:"#f764a3", p:1.5 }}>
      <Typography sx={{ color: "#fff", fontSize:12 }}>© Copyrights 2023. All rights reserved</Typography>
    </Box>
  )
}

export default Footer 